module.exports = __webpack_public_path__ + "img/avatar.77c99c35.svg";